// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js!../../styles/global.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stats-tile {
  min-width: 21.1875rem;
  height: 15.4375rem;
  flex-shrink: 0;
  border-radius: 1.875rem;
  background: #FFF;
  padding: 2.12rem 2.5rem 2.06rem 2.5rem;
  flex: 1;
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
  margin-left: 1rem;
  margin-right: 1rem;
}

/* .stats-tile:not(:first-child):not(:last-child) { */
/*   margin-left: 1.25rem; */
/*   margin-right: 1.25rem; */
/* } */
/**/
/* .stats-tile:first-child { */
/*   margin-right: 1.25rem; */
/* } */
/**/
/* .stats-tile:last-child{ */
/*   margin-left: 1.25rem; */
/* } */

.stat {
  color: var(--primary);
  font-size: 5rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-transform: capitalize;
}


.stat-li {
  color: var(--primary) !important;
}

.stat-points {
  color: rgba(30, 30, 30, 0.90); 
  font-weight: 500;
  font-size: 0.875rem;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin: 0.5rem 0;
}

.stat-text-bottom {
  margin-top: 0.88rem;
}

a.stat-link, a:link.stat-link, a:visited.stat-link {
  color: var(--text-color-grey) !important;
  font-weight: 500 !important;
}

p.stats-link {
  color: var(--text-color-grey) !important;
  font-weight: 500 !important;
}

.stat-text-bottom:hover {
  filter: brightness(80%);
}

.stat-tile-transition {
  transition: ease-in-out 200ms;
}

.right-arrow {
  display: flex;
  /* width: 0.9375rem; */
  /* height: 0.9375rem; */
  margin: 0.25rem 0 0.19rem 0.38rem;
  /* padding: 0.19531rem 0rem; */
  justify-content: center;
  align-items: center;
  padding: 0.2rem 0;
  /* flex-shrink: 0; */
}

`, "",{"version":3,"sources":["webpack://./src/components/atoms/statsTile/statsTile.css"],"names":[],"mappings":"AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,gBAAgB;EAChB,sCAAsC;EACtC,OAAO;EACP,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,qDAAqD;AACrD,4BAA4B;AAC5B,6BAA6B;AAC7B,MAAM;AACN,GAAG;AACH,8BAA8B;AAC9B,6BAA6B;AAC7B,MAAM;AACN,GAAG;AACH,4BAA4B;AAC5B,4BAA4B;AAC5B,MAAM;;AAEN;EACE,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;AAC5B;;;AAGA;EACE,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,iCAAiC;EACjC,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;AACtB","sourcesContent":["@import \"../../styles/global.css\";\n\n.stats-tile {\n  min-width: 21.1875rem;\n  height: 15.4375rem;\n  flex-shrink: 0;\n  border-radius: 1.875rem;\n  background: #FFF;\n  padding: 2.12rem 2.5rem 2.06rem 2.5rem;\n  flex: 1;\n  margin-top: 1.25rem;\n  margin-bottom: 1.25rem;\n  margin-left: 1rem;\n  margin-right: 1rem;\n}\n\n/* .stats-tile:not(:first-child):not(:last-child) { */\n/*   margin-left: 1.25rem; */\n/*   margin-right: 1.25rem; */\n/* } */\n/**/\n/* .stats-tile:first-child { */\n/*   margin-right: 1.25rem; */\n/* } */\n/**/\n/* .stats-tile:last-child{ */\n/*   margin-left: 1.25rem; */\n/* } */\n\n.stat {\n  color: var(--primary);\n  font-size: 5rem;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  text-transform: capitalize;\n}\n\n\n.stat-li {\n  color: var(--primary) !important;\n}\n\n.stat-points {\n  color: rgba(30, 30, 30, 0.90); \n  font-weight: 500;\n  font-size: 0.875rem;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  margin: 0.5rem 0;\n}\n\n.stat-text-bottom {\n  margin-top: 0.88rem;\n}\n\na.stat-link, a:link.stat-link, a:visited.stat-link {\n  color: var(--text-color-grey) !important;\n  font-weight: 500 !important;\n}\n\np.stats-link {\n  color: var(--text-color-grey) !important;\n  font-weight: 500 !important;\n}\n\n.stat-text-bottom:hover {\n  filter: brightness(80%);\n}\n\n.stat-tile-transition {\n  transition: ease-in-out 200ms;\n}\n\n.right-arrow {\n  display: flex;\n  /* width: 0.9375rem; */\n  /* height: 0.9375rem; */\n  margin: 0.25rem 0 0.19rem 0.38rem;\n  /* padding: 0.19531rem 0rem; */\n  justify-content: center;\n  align-items: center;\n  padding: 0.2rem 0;\n  /* flex-shrink: 0; */\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
